<template>
  <v-card>
    <v-form @submit.prevent="submitRctisForm()" ref="rctisForm">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <span class="mr-2">
              <v-icon
                :color="$store.state.global.pages.rcti.color"
              >{{$store.state.global.pages.rcti.icon}}</v-icon>
            </span>
            <span class="headline">
              Create RCTIs
              <span class="grey--text subheading">
                -
                <span class="font-weight-bold">{{projectName}}</span> Dockets for the billing period of
                <span class="font-weight-bold">{{billingPeriod}}</span>
              </span>
            </span>
          </v-flex>
          <card-divider-header></card-divider-header>

          <v-flex class="text-xs-center" xs12 v-if="working">
            <v-progress-circular indeterminate :color="$store.state.global.pages.rcti.color"></v-progress-circular>
            <div class="text-xs-center body-1 grey--text text--lighten-1 mt-3">Loading your data...</div>
          </v-flex>

          <template v-if="previewData">
            <flex-sub-header>{{ previewData.tripCount }} trips spanning {{previewData.docketCount}} dockets</flex-sub-header>
            <flex-sub-header v-if="!!previewData.adjustmentTripCount">
              <span
                class="indigo--text font-italic"
              >including {{ previewData.adjustmentTripCount }} credit and adjustment trips</span>
            </flex-sub-header>
            <v-flex v-if="!!previewData.incompleteDockets.length">
              <v-alert
                :value="true"
                type="error"
                class="mb-3"
                outline
                style="border-radius: 4px;"
              >{{ previewData.incompleteDockets.length }} dockets were excluded because some of their trips were not confirmed</v-alert>
              <div
                v-for="(docketRef) in previewData.incompleteDockets"
                :key="docketRef"
                class="text-xs-left pl-2 body-2 grey--text"
              >
                -
                <a
                  href
                  @click.prevent="searchForDocket(docketRef)"
                  class="grey--text text--darken-1"
                >{{docketRef}}</a>
              </div>
            </v-flex>
            <card-divider-header></card-divider-header>
            <flex-sub-header>Sub-Contractors</flex-sub-header>
          </template>

          <v-flex xs12 v-if="previewData">
            <v-expansion-panel popout>
              <v-expansion-panel-content v-for="(contractor,i) in previewData.subjects" :key="i">
                <div
                  slot="header"
                  class="font-weight-medium grey--text text--darken-2"
                >{{`${contractor.name} - ${contractor.adminFeePercentage}%`}}</div>
                <v-card>
                  <v-list two-line dense>
                    <v-divider></v-divider>
                    <fancy-list-tile
                      icon="mail"
                      :color="$store.state.global.pages.contractor.color"
                      title="Email"
                      :subTitle="contractor.contactEmail"
                      type="email"
                    ></fancy-list-tile>

                    <fancy-list-tile
                      icon="phone"
                      :color="$store.state.global.pages.contractor.color"
                      title="Phone"
                      :subTitle="contractor.contactPhone"
                      type="phone"
                    ></fancy-list-tile>

                    <v-divider></v-divider>
                  </v-list>
                  <v-card-text>
                    <div class="body-2">Trips - {{contractor.tripCount}}</div>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
          <flex-sub-header>
            Notes
            <div
              class="font-italic caption grey--text"
            >These notes will apply for all RCTIs about to be created</div>
          </flex-sub-header>
          <v-flex xs12 sm6>
            <v-text-field label="Internal Notes" prepend-icon="note" v-model="internalNotes"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field label="Invoice Notes" prepend-icon="note" v-model="invoiceNotes"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="close()" :color="primaryGrey">Close</v-btn>
        <v-btn
          flat
          type="submit"
          color="green darken-1"
          :disabled="!previewData"
          :loading="loading"
        >Create</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import RctiService from "@/services/requests/rctiService";
import DocketService from "@/services/requests/docketService";
export default {
  mounted() {
    this.getPreviewData();
  },
  data() {
    return {
      loading: false,
      working: false,
      internalNotes: "",
      invoiceNotes: "",
      previewData: null
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submitRctisForm() {
      if (!this.previewData.tripIds.length) {
        this.snack({ color: "yellow", text: "No trips found!" });
        return;
      }
      this.addRctis();
    },
    buildQuery() {
      var query = {};
      query.billingPeriod = this.billingPeriod;
      query.projectId = this.projectId;
      return query;
    },
    getPreviewData() {
      this.working = true;
      var getPreviewDataQuery = {
        type: "rctis",
        query: this.buildQuery()
      };
      DocketService.getPreviewData(getPreviewDataQuery)
        .then(result => {
          this.working = false;
          //console.log(result.data.result);
          this.previewData = result.data.result;
        })
        .catch(err => {
          console.log(err);
          this.working = false;
        });
    },
    addRctis() {
      this.loading = true;
      var rctis = {
        internalNotes: this.internalNotes,
        invoiceNotes: this.invoiceNotes,
        trips: this.previewData.tripIds
      };
      RctiService.addRctis(rctis)
        .then(result => {
          this.loading = false;
          this.resetForm();
          this.close();
          //console.log(result.data.result.createdRctis);
          var rctiIds = result.data.result.createdRctis.map(createdRcti => {
            return createdRcti.rcti.id;
          });
          rctiIds = JSON.stringify(rctiIds);
          this.$router.push({ name: "rcti", query: { ids: rctiIds } });
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    searchForDocket(docketRef) {
      if (docketRef.split("-").length > 1) {
        this.close();
        this.$store.commit("shared/setState", {
          prop: "billingPeriod",
          value: null
        });
      }
      this.$store.commit("trips/setState", {
        prop: "filterBy",
        value: docketRef
      });
    },
    resetForm() {
      this.internalNotes = "";
      this.invoiceNotes = "";
    }
  },
  props: {
    dialogOpen: Boolean
  },
  computed: {
    billingPeriod: Store.getSet({ store: "shared", prop: "billingPeriod" }),
    projectId: Store.getSet({ store: "shared", prop: "projectId" }),
    projectName() {
      if (!!this.projectId) {
        return this.$store.state.projects.projects.filter(project => {
          return project.id == this.projectId;
        })[0].name;
      } else {
        return "";
      }
    }
  },
  watch: {
    // billingPeriod(val) {
    //     this.previewData = null;
    //     this.getPreviewData()
    // },
    // projectId(val) {
    //     this.previewData = null;
    //     if (!!val) this.getPreviewData()
    // }
    dialogOpen(val) {
      if (val) {
        this.previewData = null;
        this.getPreviewData();
      }
    }
  }
};
</script>

<style>
</style>
